// src/font-awesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClover, faArrowsRotate, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

library.add(faClover, faArrowsRotate, faWandMagicSparkles);
